import Api from "~/service/Api";

class TourInboxImageRepository {
  fetch(query) {
    return Api.get("/tour/inbox-images", query);
  }
}

export default TourInboxImageRepository;
